<template>
  <v-card class="white vetalfa-view" :max-width="_getMaxWidth()" flat>
    <div class="vetalfa-global-header" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :breadcrumb="_getLabel('VA_CARDS')"
        :title="_getLabel('VA_CARDS')"
        hasSlotOption
      >
        <template>
          <v-icon
            @click="openAboutCardsUrl"
            size="18"
            :color="_isMobile() ? 'white' : 'primary'"
            class="mx-1 pt-1"
            >{{ mdiHelpCircle }}</v-icon
          >
        </template>
      </vetalfa-small-header>
      <v-tabs class="py-2" centered v-model="tabModel">
        <v-tab class="text-none">{{ _getLabel("CATEGORIES") }}</v-tab>
        <v-tab class="text-none">{{ _getLabel("CONTENTS") }}</v-tab>
      </v-tabs>
      <v-row justify="center" class="pa-0 ma-0">
        <v-row no-gutters class="vetalfa-max-width">
          <v-chip-group
            v-model="chipFilterContentType"
            dense
            class="ma-0 pa-0 white ml-3"
            active-class="primary white--text"
            v-if="tabModel == 1"
          >
            <v-icon
              @click="chipFilterContentType = undefined"
              v-if="chipFilterContentType !== undefined"
              color="primary"
              class="ma-0 pa-0 mr-2 vetalfa-pointer"
            >
              {{ mdiCloseCircleOutline }}
            </v-icon>
            <v-chip
              v-for="(type, typeIndex) in contentTypeOrder"
              :key="`chip-group-${type}`"
              v-show="
                chipFilterContentType === undefined ||
                chipFilterContentType == typeIndex
              "
              small
              :outlined="chipFilterContentType != typeIndex"
              color="primary"
              >{{ getContentTypeName(type) }}</v-chip
            >
          </v-chip-group>
        </v-row>
      </v-row>
      <v-row no-gutters class="py-2" v-if="tabModel == 1" justify="center">
        <v-row no-gutters class="vetalfa-max-width">
          <v-btn
            @click="sortModel.dialog = true"
            text
            small
            class="text-none primary--text"
          >
            <v-icon size="18">{{ mdiSwapVertical }}</v-icon>
            {{ sortModel.name }}
          </v-btn>
          <v-dialog
            v-model="sortModel.dialog"
            :content-class="_xsOnly() ? 'v-bottom-sheet white' : 'white'"
            transition="dialog-bottom-transition"
            max-width="700px"
          >
            <v-row aling="center" justify="start" class="pa-0 ma-0 pl-2 pt-2">
              <v-btn
                x-small
                @click="sortModel.dialog = false"
                text
                class="text-none primary--text"
                style="border: 0.5px solid rgba(242, 242, 242, 1)"
              >
                {{ _getLabel("CLOSE") }}
              </v-btn>
            </v-row>
            <v-row no-gutters class="px-3 mt-4 mb-2 caption primary--text">
              <p class="ma-0 pa-0">{{ _getLabel("SORT_BY") }}</p>
            </v-row>
            <v-row no-gutters class="ma-0 pa-0">
              <v-list-item-group
                class="ma-0 pa-0"
                v-model="sortChipModel"
                dense
                style="width: 100%"
                active-class=""
                mandatory
              >
                <v-list-item
                  v-for="(sortType, typeIndex) in [
                    'ALPHABETICAL_ORDER',
                    'BIGGER_SCORE',
                    'SMALLER_SCORE',
                    'BIGGER_PROGRESS',
                    'SMALLER_PROGRESS',
                  ]"
                  :key="`chip-group-${sortType}`"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active || sortChipModel == typeIndex"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">{{
                        _getLabel(sortType)
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-row>
            <div style="height: 50px; background-color: white"></div>
          </v-dialog>
        </v-row>
      </v-row>
    </div>
    <div ref="screenContent" style="height: 100%">
      <v-tabs-items v-model="tabModel" class="ma-0 pa-0">
        <v-tab-item class="ma-0 pa-0">
          <v-row no-gutters>
            <v-col
              class="ma-0 pa-0"
              v-for="card in orderedCardsProgressByContentType"
              :key="card.content_type"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card
                @click="startSelection(card.content_type)"
                class="mx-5 my-2 py-2 home-card vetalfa-pointer"
                outlined
                height="100"
              >
                <v-row no-gutters class="vetalfa-row pl-4 pr-2" align="center">
                  <v-icon size="32" color="primary">{{
                    _icon(getContentTypeIcon(card.content_type))
                  }}</v-icon>
                  <v-col class="pl-6 vetalfa-row">
                    <v-row
                      no-gutters
                      class="vetalfa-row"
                      align-content="space-around"
                    >
                      <p
                        class="primary--text subtitle-2 pa-0 ma-0"
                        style="width: 100%"
                      >
                        {{ getContentTypeName(card.content_type) }}
                      </p>
                      <v-card
                        class="primary--text caption px-2 ma-0"
                        flat
                        style="border-radius: 5px; background-color: #f2f2f2"
                      >
                        <v-row no-gutters align="center">
                          <span class="pt-1">
                            {{
                              `${_getLabel(
                                "FLASH_CARDS_SCORE"
                              )}: ${_formatNumber(
                                _roundNumber(card.average_latest_score || 0, 1)
                              )}`
                            }}
                          </span>
                          <v-rating
                            :empty-icon="mdiStarOutline"
                            :full-icon="mdiStar"
                            :half-icon="mdiStarHalfFull"
                            dense
                            half-increments
                            hover
                            length="5"
                            size="18"
                            background-color="rgba(255, 199, 1, 1)"
                            color="rgba(255, 199, 1, 1)"
                            class="pl-2"
                            :value="card.average_latest_score || 0"
                            readonly
                          ></v-rating>
                        </v-row>
                      </v-card>
                      <v-col cols="12" class="ma-0 pa-0">
                        <v-row no-gutters justify="start">
                          <span class="primary--text caption pa-0 ma-0">
                            {{
                              `${_getLabel(
                                "PROGRESS"
                              )}: ${getPercentualProgress(card)}`
                            }}
                          </span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-icon size="12" color="grey">{{ mdiChevronRight }}</v-icon>
                </v-row>
              </v-card>
            </v-col>

            <v-col
              v-if="cardsProgress && cardsProgress.length"
              class="white"
              :class="[_xsOnly() ? 'flash-cards-menu-action' : 'mt-7']"
              cols="12"
            >
              <v-row no-gutters justify="center">
                <v-btn
                  @click="openAboutCardsUrl"
                  rounded
                  text
                  small
                  class="primary--text white text-none text-decoration-underline"
                >
                  {{ _getLabel("HOW_IT_WORKS_QUESTION") }}
                </v-btn>
              </v-row>
              <v-row
                no-gutters
                justify="center"
                class="vetalfa-padding-bottom-notch"
              >
                <v-btn
                  @click="startSelection()"
                  rounded
                  large
                  class="subtitle-1 primary white--text text-none mt-3"
                  style="width: 200px"
                >
                  {{ _getLabel("START") }}
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" class="white" style="height: 200px"></v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item class="ma-0 pa-0">
          <v-virtual-scroll
            v-if="cardsProgress.length && tabModel == 1"
            :items="[...orderedCardsProgressByContent, {}, {}, {}]"
            :item-height="100"
            :bench="0"
            :height="virtualScrollHeightComputed"
            id="items-virtual-scroll"
            class="ma-0 pa-0"
          >
            <template v-slot="{ item }">
              <div>
                <v-row class="ma-0 pa-0 mx-2 pb-4">
                  <v-card
                    v-if="item.content_name"
                    outlined
                    :height="`90px`"
                    style="
                      width: 100%;
                      border: 1px solid #eeeeee !important;
                      border-radius: 10px;
                    "
                    class="ma-0 pa-0 white px-2"
                    @click="getCardsByContentIdClick(item)"
                  >
                    <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                      <v-col :cols="11" class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0" align="center">
                          <p
                            v-html="item.content_name"
                            class="ma-0 items-title items-two-lines-clamp"
                          ></p>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                          <p
                            class="items-description-label text-center mt-1 ma-0 pa-0"
                          >
                            {{ getContentTypeName(item.content_type) }}
                          </p>
                        </v-row>
                        <v-row no-gutters align="center" class="mt-2">
                          <v-card
                            class="primary--text caption px-2 ma-0"
                            flat
                            style="
                              border-radius: 5px;
                              background-color: #f2f2f2;
                            "
                          >
                            <v-row no-gutters align="center">
                              <span class="caption primary--text">
                                {{
                                  `${_getLabel(
                                    "FLASH_CARDS_SCORE"
                                  )}: ${_formatNumber(
                                    _roundNumber(
                                      item.average_latest_score || 0,
                                      1
                                    )
                                  )}`
                                }}
                              </span>
                              <v-rating
                                :empty-icon="mdiStarOutline"
                                :full-icon="mdiStar"
                                :half-icon="mdiStarHalfFull"
                                dense
                                half-increments
                                hover
                                length="5"
                                size="18"
                                background-color="rgba(255, 199, 1, 1)"
                                color="rgba(255, 199, 1, 1)"
                                class="pl-2"
                                :value="item.average_latest_score || 0"
                                readonly
                              ></v-rating>
                            </v-row>
                          </v-card>
                          <span class="primary--text caption pa-0 ma-0 ml-2">
                            {{
                              `${_getLabel(
                                "PROGRESS"
                              )}: ${getPercentualProgress(item)}`
                            }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col :cols="1" class="ma-0 pa-0">
                        <v-row justify="end" class="ma-0 pa-0 pr-1">
                          <v-icon x-small color="#747678">{{
                            mdiChevronRight
                          }}</v-icon>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </div>
            </template>
          </v-virtual-scroll>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <vetalfa-dialog
      v-on:dialogClose="selectionModel = false"
      :bottom="false"
      :toggleModel="selectionModel"
      :fullscreen="_xsOnly()"
      max-width="700px"
      :smallHeader="false"
      :featureMode="false"
      :height="_getDialogHeight(0.6)"
    >
      <template v-slot:header>
        <v-row
          no-gutters
          align="center"
          justify="space-between"
          class="px-2 vetalfa-padding-top-notch mt-4"
        >
          <v-col>
            <v-row no-gutters align="start" class="vetalfa-row">
              <v-icon size="22" color="primary" class="mx-1 pt-1">{{
                _icon("flashcardsIcon")
              }}</v-icon>
              <span
                class="ma-0 pa-0 ml-1 primary--text subtitle-1 font-weight-bold"
              >
                Flashcards
              </span>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="1">
            <v-row no-gutters class="vetalfa-row" align="start">
              <v-btn :disabled="loading" icon @click="selectionModel = false">
                <v-icon size="20" color="primary">{{ mdiClose }}</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <v-row no-gutters>
        <v-col class="ma-0 pa-0" cols="12">
          <v-row no-gutters class="pa-4 pb-1">
            <p class="primary--text subtitle-1 pa-0 ma-0">
              {{ _getLabel("FLASH_CARDS_CATEGORIES_SELECTION_TEXT") }}
            </p>
          </v-row>
          <v-row no-gutters class="pa-2">
            <chip-group
              v-if="selectionModel"
              v-on:selectChip="selectChip"
              :items="availableCategories"
              class="ma-0 pa-0 mt-n6"
              :defaultValue="categoryModel"
            ></chip-group>
          </v-row>

          <v-row v-if="availableClasses.length" no-gutters class="px-4 pb-1">
            <p class="primary--text subtitle-1 pa-0 ma-0">
              {{ _getLabel("FLASH_CARDS_SELECTION_TYPE") }}
            </p>
          </v-row>
          <v-row v-if="availableClasses.length" no-gutters class="pa-2 px-4">
            <v-radio-group v-model="selectionType" row class="ma-0 pa-0">
              <v-radio
                :label="_getLabel('FLASH_CARDS_CLASSES_SELECTION_RADIO')"
                :value="0"
              ></v-radio>
              <v-radio
                :label="_getLabel('FLASH_CARDS__SINGLE_ITEM_SELECTION_RADIO')"
                :value="1"
              ></v-radio>
            </v-radio-group>
          </v-row>

          <v-row
            v-if="availableClasses.length && selectionType == 0"
            no-gutters
            class="px-4 pb-1"
          >
            <p class="primary--text subtitle-1 pa-0 ma-0">
              {{ _getLabel("FLASH_CARDS_CLASSES_SELECTION_TEXT") }}
            </p>
          </v-row>
          <v-row
            v-if="availableClasses.length && selectionType == 0"
            no-gutters
            class="pa-2"
          >
            <chip-group
              v-if="selectionModel"
              v-on:selectChip="selectChipClass"
              :items="availableClasses"
              class="ma-0 pa-0 mt-n6"
              :defaultValue="classModel"
            ></chip-group>
          </v-row>
          <v-row
            v-if="
              availableSingleContentList &&
              availableSingleContentList.length &&
              selectionType == 1
            "
            no-gutters
            class="px-4 pb-1"
          >
            <p class="primary--text subtitle-1 pa-0 ma-0">
              {{ _getLabel("FLASH_CARDS_SELECT_SINGLE_ITEM_LABEL") }}
            </p>
          </v-row>
          <v-row
            v-if="
              availableSingleContentList &&
              availableSingleContentList.length &&
              selectionType == 1
            "
            no-gutters
            class="pa-2"
          >
            <v-autocomplete
              v-model="targetContent"
              :key="targetContent"
              :search-input.sync="search"
              @change="search = ''"
              :items="availableSingleContentList"
              item-text="name"
              return-object
              :placeholder="_getLabel('SELECT')"
              :menu-props="{
                'allow-overflow': true,
                maxHeight: _isMobile() ? 200 : 300,
                top: true,
                'offset-y': false,
                closeOnContentClick: false,
                nudgeBottom: search && (_isIosWeb() || _isIos()) ? 240 : 0,
                offsetOverflow: true,
                returnObject: true,
              }"
              persistent-hint
              hide-details
              class="px-2 pa-0"
              filled
              dense
              outlined
              :disabled="loading"
              :filter="customFilter"
              clearable
            >
              <template v-slot:item="{ item }">
                <p
                  class="ma-0 pa-0 my-2 vetalfa-autocomplete-component-size v-list-item__content v-list-item__title"
                >
                  {{ item.name.trim() }}
                </p>
              </template>
            </v-autocomplete>
          </v-row>
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-col cols="12" class="mb-4">
          <v-row class="ma-0 vetalfa-padding-bottom-notch" justify="center">
            <v-btn
              @click="getCardsClick"
              rounded
              :disabled="
                (typeof classModel != 'number' && targetContent == null) ||
                invalidCategoryModel
              "
              :loading="loading"
              large
              class="subtitle-1 primary white--text text-none px-12"
            >
              {{ _getLabel("CONTINUE") }}
            </v-btn>
          </v-row>
        </v-col>
      </template>
    </vetalfa-dialog>
    <vetalfa-flash-cards
      v-if="allowFlashcardsComponent && (contentType || targetContent)"
      :contentType="contentType"
      :subject="subjectName"
      :categoryName="categoryName"
    ></vetalfa-flash-cards>
  </v-card>
</template>

<style scoped>
.flash-cards-menu-action {
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 20px 20px 20px 20px !important;
  left: 50%;
  transform: translateX(-50%);
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  mdiStarOutline,
  mdiStarHalfFull,
  mdiStar,
  mdiCloseCircleOutline,
  mdiClose,
  mdiChevronLeft,
  mdiChevronRight,
  mdiSwapVertical,
  mdiHelpCircle,
} from "@mdi/js";
import ChipGroup from "@/components/ChipGroup.vue";
import Flashcards from "@/components/Flashcards.vue";
import systems from "@/constants/systems.enums.js";
export default {
  name: "FlashcardsMenu",
  components: {
    "chip-group": ChipGroup,
    "vetalfa-flash-cards": Flashcards,
  },
  data() {
    return {
      sortModel: {
        name: this._getLabel("ALPHABETICAL_ORDER"),
        value: "content_name",
        dialog: false,
        direction: "asc",
      },
      sortChipModel: 0,
      contentTypeOrder: [4, 1, 2, 3],
      tabModel: 0,
      mdiSwapVertical,
      mdiChevronLeft,
      mdiChevronRight,
      mdiStarOutline,
      mdiStarHalfFull,
      mdiStar,
      mdiCloseCircleOutline,
      mdiClose,
      mdiHelpCircle,
      selectionModel: false,
      categoryModel: null,
      contentType: null,
      classModel: null,
      selectionType: 0,
      targetContent: null,
      scrollHeight: 0,
      chipFilterContentType: undefined,
      search: "",
      allowFlashcardsComponent: false,
    };
  },
  computed: {
    ...mapGetters("preferences", ["cardsProgress", "searchList"]),
    ...mapGetters("general", ["loading"]),
    virtualScrollHeightComputed() {
      return this.scrollHeight ? this.scrollHeight - 100 : 0;
    },
    categoryName() {
      return this.contentType
        ? this.contentType.name
        : this.targetContent
        ? this.targetContent.categoryName
        : this._getLabel("DISEASES_TITLE");
    },
    subjectName() {
      return this.contentType
        ? this.contentType.card_class
        : this.targetContent
        ? this.targetContent.name
        : "";
    },
    availableSingleContentList() {
      return (this.searchList || [])
        .filter((item) => {
          if (item.card && typeof this.categoryModel == "number") {
            return (
              (this.categoryModel == 0 &&
                item.topic === this._getLabel("DISEASES_TITLE")) ||
              item.category == [1, 4, 5][this.categoryModel - 1]
            );
          }
        })
        .map((item) => {
          return {
            name: item.name.trim(),
            id: item.id,
            categoryName: this.getContentTypeName(this.categoryModel),
          };
        });
    },
    invalidCategoryModel() {
      return typeof this.categoryModel != "number";
    },
    orderedCardsProgressByContentType() {
      let ordered = [];
      if (this.cardsProgress && this.cardsProgress.length) {
        this.contentTypeOrder.forEach((content_type) => {
          let item = {
            content_type,
            total: 0,
            answers_total: 0,
            average_latest_score: 0,
          };
          this.cardsProgress.forEach((p) => {
            if (p.content_type == content_type) {
              item.total += p.total;
              if (item.answers_total + p.answers_total > 0) {
                item.average_latest_score =
                  (p.average_latest_score * p.answers_total +
                    item.answers_total * item.average_latest_score) /
                  (item.answers_total + p.answers_total);
              }
              item.answers_total += p.answers_total;
            }
          });
          item["progress"] = Math.round(
            (item.answers_total / item.total) * 100,
            0
          );
          ordered.push(item);
        });
      }
      return ordered;
    },
    orderedCardsProgressByContent() {
      return this._sortByProp(
        (this.cardsProgress || []).filter((item) => {
          return (
            this.chipFilterContentType === undefined ||
            this.contentTypeOrder[this.chipFilterContentType] ==
              item.content_type
          );
        }),
        this.sortModel.value,
        this.sortModel.direction === "asc"
      );
    },
    availableCategories() {
      let categories = [];
      this.contentTypeOrder.forEach((category) => {
        categories.push(this.getContentTypeName(category));
      });
      return categories;
    },
    classSystem() {
      let obj = {};
      for (let item of systems) {
        for (let subItem of item.classes) {
          obj[subItem] = item.system;
        }
      }
      return obj;
    },
    availableClasses() {
      if (!this.searchList) return [];
      const { cardsProgress, categoryModel, searchList, classSystem } = this;
      let classes = [];
      if (
        typeof categoryModel == "number" &&
        cardsProgress &&
        cardsProgress.length
      ) {
        let content_type = this.contentTypeOrder[categoryModel];
        for (let item of cardsProgress) {
          if (item.content_type == content_type) {
            let tempClasses = searchList.find(
              (i) => i.id == item.content_id
            ).classes;
            if (content_type == 1) {
              tempClasses = tempClasses
                .map((c) => classSystem[c.trim()])
                .filter((c) => {
                  return !!c;
                });
            }
            classes = [...classes, ...tempClasses];
          }
        }
      }
      return [...new Set(classes)].sort();
    },
  },
  methods: {
    ...mapActions("general", [
      "showAlert",
      "openExternalUrl",
      "logEvent",
      "displayHelpArticle",
    ]),
    ...mapActions("preferences", [
      "getCardsByContentId",
      "getCardsProgress",
      "getCardsByProps",
      "getSearchList",
    ]),
    customFilter(_item, queryText, itemText) {
      itemText = this._createIdentifier(itemText);
      queryText = this._createIdentifier(queryText);
      return itemText.includes(queryText);
    },
    openAboutCardsUrl() {
      this.logEvent("flashcards_how_it_works");
      this.displayHelpArticle({ id: process.env.VUE_APP_FAQ_FLASH_CARDS });
    },
    getCardsByContentIdClick(item) {
      this.allowFlashcardsComponent = true;
      if (item) {
        this.targetContent = {
          name: item.content_name,
          id: item.content_id,
          categoryName: this.getContentTypeName(item.content_type),
        };
        this.contentType = null;
      }
      this.getCardsByContentId(this.targetContent.id);
    },
    getCardsClick() {
      this.allowFlashcardsComponent = false;
      this.$nextTick(() => {
        if (
          this.invalidCategoryModel ||
          (typeof this.classModel != "number" && this.targetContent == null)
        ) {
          return this.showAlert({
            text: this._getMessage("FLASH_CARDS_SELECT_CATEGORY_AND_CLASS"),
          });
        }
        if (this.targetContent && this.selectionType == 1) {
          return this.getCardsByContentIdClick();
        }
        let content_type = this.contentTypeOrder[this.categoryModel];
        this.contentType = {
          name: this.getContentTypeName(content_type),
          card_class: this.availableClasses[this.classModel],
          content_type,
        };
        this.getCardsByProps({
          content_type,
          card_class: this.contentType.card_class,
        });
        this.allowFlashcardsComponent = true;
      });
    },
    startSelection(content_type) {
      this.selectContentType(content_type);
      this.selectionModel = true;
      this.classModel = null;
    },
    selectContentType(content_type) {
      this.categoryModel =
        typeof content_type == "number"
          ? this.contentTypeOrder.indexOf(content_type)
          : null;
    },
    selectChip(val) {
      this.categoryModel = val;
    },
    selectChipClass(val) {
      this.classModel = val;
    },
    getContentTypeName(content_type) {
      return this._getLabel(
        {
          1: "SYSTEMIC_DRUGS",
          2: "DERMATOLOGICAL_TOPICS",
          3: "OPTHALMIC_AGENTS",
          4: "DISEASES_AND_TREATMENT",
        }[content_type]
      );
    },
    getContentTypeIcon(content_type) {
      return {
        1: "drugs",
        2: "dermatologic",
        3: "ophtalmic",
        4: "diseases",
      }[content_type];
    },
    getPercentualProgress(card) {
      let minorThanSymbol = !!card.progress && card.progress < 1 ? "<" : "";
      return `${minorThanSymbol}${
        minorThanSymbol ? "1" : this._formatNumber(card.progress)
      }%`;
    },
  },
  watch: {
    sortChipModel(val) {
      this.sortModel = [
        {
          name: this._getLabel("ALPHABETICAL_ORDER"),
          value: "content_name",
          dialog: false,
          direction: "asc",
        },
        {
          name: this._getLabel("BIGGER_SCORE"),
          value: "average_latest_score",
          dialog: false,
          direction: "desc",
        },
        {
          name: this._getLabel("SMALLER_SCORE"),
          value: "average_latest_score",
          dialog: false,
          direction: "asc",
        },
        {
          name: this._getLabel("BIGGER_PROGRESS"),
          value: "progress",
          dialog: false,
          direction: "desc",
        },
        {
          name: this._getLabel("SMALLER_PROGRESS"),
          value: "progress",
          dialog: false,
          direction: "asc",
        },
      ][val];
    },
    targetContent() {
      this.contentType = null;
    },
    selectionType() {
      this.classModel = null;
      this.targetContent = null;
    },
    categoryModel() {
      this.classModel = undefined;
      this.targetContent = null;
      this.contentType = null;
      this.$nextTick(() => {
        this.classModel = null;
      });
    },
    tabModel() {
      this.$nextTick(() => {
        this._setupScreenSizes(this);
      });
    },
    classModel() {
      this.targetContent = null;
      this.contentType = null;
    },
  },
  async mounted() {
    this._setupScreenSizes(this);
    await this.$nextTick();
    this.getCardsProgress();
  },
  created() {
    if (!this.searchList) {
      this.getSearchList();
    }
  },
};
</script>